import { render, staticRenderFns } from "./Staff-Personal-Info.vue?vue&type=template&id=56fcb309&"
import script from "./Staff-Personal-Info.vue?vue&type=script&lang=js&"
export * from "./Staff-Personal-Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports